import React from 'react';

import Footer from '../components/Footer';
import '../App.css';

const ShipDrydockServices = () => {
  return (
    <div>
      

      {/* Cover Image Section */}
      <div className="service-cover">
        <img src="/images/drydock.webp" alt="Ship Drydock Services" className="service-cover-image" />
        <div className="service-cover-text">
          <h1>Ship Drydock Services</h1>
          <p>Precision | Safety | Compliance</p>
        </div>
      </div>

      {/* Main Content */}
      <section className="service-section container">
        {/* Overview */}
        <div className="intro-text">
          <h2>Overview</h2>
          <p>
            We provide expert drydocking services that cover everything from planning to post-docking inspections. Our experienced teams work closely with class societies and port authorities to ensure smooth execution, full compliance, and minimized downtime.
          </p>
        </div>

        {/* Drydock Services List */}
        <div className="service-grid">
          <div className="service-card">
            <img src="/images/hulls.webp" alt="Hull Repairs" className="service-card-image" />
            <div className="service-card-content">
              <h3>Hull Inspection & Steel Repairs</h3>
              <ul>
                <li>Complete structural integrity checks</li>
                <li>Steel renewal and fabrication</li>
                <li>Ultrasonic thickness gauging</li>
              </ul>
            </div>
          </div>

          <div className="service-card">
            <img src="/images/painting.webp" alt="Painting and Blasting" className="service-card-image" />
            <div className="service-card-content">
              <h3>Blasting & Painting</h3>
              <ul>
                <li>Hull blasting and coating application</li>
                <li>Anti-corrosion and antifouling systems</li>
                <li>Eco-friendly paint options</li>
              </ul>
            </div>
          </div>

          <div className="service-card">
            <img src="/images/mechinery.webp" alt="Machinery Overhaul" className="service-card-image" />
            <div className="service-card-content">
              <h3>Machinery Overhaul</h3>
              <ul>
                <li>Main and auxiliary engine service</li>
                <li>Propulsion and steering gear maintenance</li>
                <li>Condition monitoring and diagnostics</li>
              </ul>
            </div>
          </div>

          <div className="service-card">
            <img src="/images/class.webp" alt="Class Coordination" className="service-card-image" />
            <div className="service-card-content">
              <h3>Class & Regulatory Coordination</h3>
              <ul>
                <li>Documentation and class survey handling</li>
                <li>Dry dock compliance reporting</li>
                <li>Liaison with port and flag authorities</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ShipDrydockServices;
